import { memo } from 'react'

// Изображение телеграм-звезды вместо иконки tabler.
// size задаёт сторону в px (по умолчанию 16), className — доп. классы обёртки.
function StarIcon({ size = 16, className = '' }) {
  return (
    <img loading="eager"
      src="/images/categories/star.webp"
      alt=""
      aria-hidden="true"
      draggable="false"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`inline-block shrink-0 object-contain ${className}`}
    />
  )
}

export default memo(StarIcon)
